var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumorous(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.239,
    height: 34.239,
    viewBox: "0 0 34.239 34.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humorous",
    transform: "translate(0 -102.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11620",
    "data-name": "Path 11620",
    d: "M14.23,43.925A4.383,4.383,0,0,0,10.5,46.117a1.469,1.469,0,0,0,2.543,1.447,1.381,1.381,0,0,1,2.3,0,1.4,1.4,0,0,0,1.25.767,1.951,1.951,0,0,0,.723-.176,1.49,1.49,0,0,0,.548-1.995,4.078,4.078,0,0,0-3.639-2.192Z",
    transform: "translate(7.867 69.324)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11621",
    "data-name": "Path 11621",
    d: "M9.676,47.509a1.4,1.4,0,0,0,1.249.767,1.623,1.623,0,0,0,.789-.2,1.469,1.469,0,0,0,.548-1.973,4.231,4.231,0,0,0-7.387,0A1.447,1.447,0,0,0,7.33,47.553a1.4,1.4,0,0,1,2.345,0Z",
    transform: "translate(3.629 69.334)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11622",
    "data-name": "Path 11622",
    d: "M17.119,37.755A17.119,17.119,0,1,0,29.225,42.77,17.12,17.12,0,0,0,17.119,37.755Zm0,31.587A14.489,14.489,0,1,1,27.343,65.1,14.466,14.466,0,0,1,17.119,69.342Z",
    transform: "translate(0 64.643)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11623",
    "data-name": "Path 11623",
    d: "M17.238,48.35H7.746a1.6,1.6,0,0,0-1.578,1.578,5.984,5.984,0,0,0,6.269,5.655,5.984,5.984,0,0,0,6.269-5.655,1.578,1.578,0,0,0-1.469-1.578Z",
    transform: "translate(4.68 72.681)",
    fill: "#ef3f4e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumorous);
export default __webpack_public_path__ + "static/media/humorous.1d11a768270a919df4b92e5f3a0fe9ef.svg";
export { ForwardRef as ReactComponent };